import { useMemo } from "react";
import { useReadContracts } from "wagmi";
import { reservoirAbi } from "@/abis/reservoir";
import { RESERVOIR_ADDRESSES } from "@/constants/contracts";
import { STRIKE_PRICES } from "@/constants/strikePrices";

const STRIKE_TO_INDEX: Record<string, number> = STRIKE_PRICES.reduce(
  (acc, strike, index) => {
    acc[strike.toString()] = index;
    return acc;
  },
  {} as Record<string, number>,
);

export function useUserWhaleDeposits(address?: `0x${string}`) {
  const whaleDepositChecks = address
    ? RESERVOIR_ADDRESSES.map((r) => ({
        address: r as `0x${string}`,
        abi: reservoirAbi,
        functionName: "whitelistDeposit",
        args: [address],
      }))
    : [];
  const { data: whaleDepositData, refetch } = useReadContracts({
    contracts: whaleDepositChecks,
    query: { enabled: !!address && whaleDepositChecks.length > 0 },
  });
  const userWhaleDeposits = useMemo(() => {
    if (!whaleDepositData) return {} as Record<string, bigint>;
    const indexToDeposit = whaleDepositData.reduce(
      (acc, result, index) => {
        if (result.status === "success") {
          acc[index] = result.result as bigint;
        }
        return acc;
      },
      {} as Record<number, bigint>,
    );
    const strikeToDeposit: Record<string, bigint> = {};
    const INDEX_TO_STRIKE = Object.entries(STRIKE_TO_INDEX).reduce(
      (acc, [strike, index]) => {
        if (index !== undefined) {
          acc[index.toString()] = strike;
        }
        return acc;
      },
      {} as Record<string, string>,
    );
    Object.entries(indexToDeposit).forEach(([indexStr, amount]) => {
      const strike = INDEX_TO_STRIKE[indexStr];
      if (strike) {
        strikeToDeposit[strike] = amount;
      }
    });
    return strikeToDeposit;
  }, [whaleDepositData]);
  return { userWhaleDeposits, refetch };
}
